import { Link } from 'react-router-dom'
import { setAuthToken } from 'Actions/user'
import { Button, Form, Input } from 'antd'

export LoginForm = ({ onFinish, onChange, buttonEnabled, loading, buttonText, selfSignUpEnabled }) ->

  <Form
    onFinish={onFinish}
    className="entry-form"
  >
    <Form.Item name="username" rules={[{ required: false }]}>
      <Input
        size="large"
        placeholder="Username or email"
        onChange={onChange}
      />
    </Form.Item>
    <Form.Item name="password" rules={[{ required: false }]}>
      <Input
        size="large"
        placeholder="Password"
        onChange={onChange}
        type="password"
      />
    </Form.Item>
    <Form.Item style={{ marginBottom: 0, marginTop: 34 }}>
      <Button
        disabled={!buttonEnabled}
        size="large"
        loading={loading}
        htmlType="submit"
        className="entry-form-button"
      >
        { buttonText }
      </Button>
    </Form.Item>
    {
      if selfSignUpEnabled is true
        <Form.Item style={{ marginBottom: 0, marginTop: 34 }}>
          <Link to="/signup">Or sign up here</Link>
        </Form.Item>
    }
  </Form>

export SignUpForm = ({ onFinish, onChange, buttonEnabled, loading, buttonText }) ->

  <Form
    onFinish={onFinish}
    className="entry-form"
  >
    <Form.Item name="username" rules={[{ required: false }]}>
      <Input
        size="large"
        placeholder="Username"
        onChange={onChange}
      />
    </Form.Item>
    <Form.Item name="firstname" rules={[{ required: true }]}>
      <Input
        size="large"
        placeholder="First name"
        onChange={onChange}
      />
    </Form.Item>
    <Form.Item name="lastname" rules={[{ required: true }]}>
      <Input
        size="large"
        placeholder="Last name"
        onChange={onChange}
      />
    </Form.Item>
    <Form.Item name="email" rules={[{ required: true }]}>
      <Input
        size="large"
        placeholder="Email"
        onChange={onChange}
      />
    </Form.Item>
    <Form.Item name="password" rules={[{ required: true }]}>
      <Input
        size="large"
        placeholder="Password"
        onChange={onChange}
        type="password"
      />
    </Form.Item>
    <Form.Item style={{ marginBottom: 0, marginTop: 34 }}>
      <Button
        disabled={!buttonEnabled}
        size="large"
        loading={loading}
        htmlType="submit"
        className="entry-form-button"
      >
        {buttonText}
      </Button>
    </Form.Item>
  </Form>
